import { render, staticRenderFns } from "./makevlogskill.vue?vue&type=template&id=b565ab7e&scoped=true&"
import script from "./makevlogskill.vue?vue&type=script&lang=js&"
export * from "./makevlogskill.vue?vue&type=script&lang=js&"
import style0 from "./makevlogskill.vue?vue&type=style&index=0&id=b565ab7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565ab7e",
  null
  
)

export default component.exports